<template>
  <div>
    <form-filtered-select
      :selected-key="selectedServiceLeg ? selectedServiceLeg.value : null"
      :options="service_LegOptions"
      :invalid="invalid"
      placeholder="Service Legs"
      @updateDropdownValue="onUpdateValue"
      @close="$emit('close')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedServiceLeg: null
    }
  },
  computed: {
    ...mapGetters('serviceLeg', ['service_LegOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedServiceLeg && this.value.value !== this.selectedServiceLeg.value) {
        this.selectedServiceLeg = this.value
      }
    }
  },
  mounted () {
    this.selectedServiceLeg = this.value
    this.$watch('selectedServiceLeg', function () {
      this.$emit('input', this.selectedServiceLeg)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedServiceLeg = value
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  &__content-wrapper {
    z-index: 3000 !important;
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
